export default __webpack_public_path__ + "static/media/p7-7.a91f7b33.png";